import React, { useState, useContext } from 'react';
import {
  Row, Col,
  Divider,
  Button,
  Form, Input, Select,
  Space,
} from 'antd';
import {
  CloseOutlined,
  CheckOutlined,
} from '@ant-design/icons';
import { MasterContext } from '../../App';
import './style';
export default React.forwardRef((props, ref) => {
  const { goods_category, currentUser, authorities } = useContext(MasterContext);
  const { mode, goods, onCloseCallback, onSaveCallback } = props;
  const [form] = Form.useForm();
  const [prefix, setPrefix] = useState(goods? goods.prefix : '');
  const [isReadonly, setReadonly] = useState(mode === 'edit');
  const [goodsNameCn, setGoodsNameCn] = useState(goods ? goods.name_cn : undefined);
  const [goodsNameEn, setGoodsNameEn] = useState(goods ? goods.name_en : undefined);
  const [remark, setRemark] = useState(goods ? goods.remark : undefined);
  const [categoryId, setCategoryId] = useState(goods ? goods.category_id : undefined);
  const onSave = async () => {
    try {
      const values = await form.validateFields();
      console.log('onSave:', values);
      if (onSaveCallback) {
        onSaveCallback(values);
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onClose = async () => {
    try {
      if (onCloseCallback) {
        onCloseCallback();
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const initValue = [
    { name: ['id'], value: goods ? goods.id : undefined },
    { name: ['name_cn'], value: goodsNameCn },
    { name: ['name_en'], value: goodsNameEn },
    { name: ['remark'], value: remark },
    { name: ['category_id'], value: categoryId },
    { name: ['prefix'], value: prefix },
  ];

  return (
    <Form style={{ padding: '1rem' }} form={form} preserve={false} onFinish={onSave} fields={initValue}>
      <Row>
        <Col span={12}>
          <Form.Item hidden={true} name="id">
            <Input />
          </Form.Item>
          <Form.Item label="产品名称(英文)" name="name_en" rules={[{ required: true, message: '请输入产品名称!' }]}>
            <Input autoComplete="off" disabled={isReadonly} placeholder="请输入英文产品名称" style={{ width: '100%' }} onChange={(e) => setGoodsNameEn(e.target.value)} />
          </Form.Item>
          <Form.Item label="产品名称(中文)" name="name_cn" rules={[{ required: true, message: '请输入产品名称!' }]}>
            <Input autoComplete="off"  disabled={isReadonly} placeholder="请输入中文产品名称" style={{ width: '100%' }} onChange={(e) => setGoodsNameCn(e.target.value)} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="报关品名" name="category_id" rules={[{ required: true, message: '请选择报关品名!' }]}>
            <Select
              disabled={isReadonly}
              showSearch="true"
              placeholder="请选择报关品名"
              onChange={(value) => setCategoryId(value)}
              style={{ width: '100%' }}
            >
              {goods_category.map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="　备　　注" name="remark">
            <Input
              autoComplete="off" 
              disabled={isReadonly}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="请输入备注"
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider style={{ margin: '1rem 0' }} />
      <div className="page-footer">
        <div>
        <Form.Item label={<strong>产品号前缀</strong>} name="prefix">
            <Input
              disabled={isReadonly}
              onChange={(e) => setPrefix(e.target.value)}
              placeholder="请输入产品号前缀"
            />
          </Form.Item>
        </div>
        <Space size="large">
          <Button onClick={onClose} icon={<CloseOutlined />}>关 闭</Button>
          {
            !isReadonly && <div style={{ display: 'flex', alignItems: 'center' }}>
              {(authorities.find(x => x === 'create_buyer' || x === 'edit_buyer') || currentUser.category_id === 1) && <Button htmlType="submit" type="primary" icon={<CheckOutlined />}>保 存</Button>}

            </div>
          }
          {
            isReadonly && <div style={{ display: 'flex', alignItems: 'center' }}>
              {(authorities.find(x => x === 'create_buyer' || x === 'edit_buyer') || currentUser.category_id === 1) && <Button onClick={() => setReadonly(false)} type="primary" icon={<CheckOutlined />}>编 辑</Button>}
            </div>
          }
        </Space>
      </div>
    </Form>)
});
